import { render } from "./modifyCom.vue?vue&type=template&id=7faea4fa&scoped=true"
import script from "./modifyCom.vue?vue&type=script&lang=js"
export * from "./modifyCom.vue?vue&type=script&lang=js"

import "./modifyCom.vue?vue&type=style&index=0&id=7faea4fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7faea4fa"]])

export default __exports__